import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  withinUse: boolean;
};

export const NewArrivalSortTicketLabel: FC<Props> = ({ withinUse }) => {
  return (
    <>
      {withinUse ? (
        <span className={styles.ticketLabel.withinUse}>新着チケット使用中</span>
      ) : (
        <span className={styles.ticketLabel.futureUse}>新着チケット使用予定</span>
      )}
    </>
  );
};
